var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1280.000000pt",
    height: "1158.000000pt",
    viewBox: "0 0 1280.000000 1158.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1158.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1233 11119 c-495 -58 -905 -421 -1035 -917 -29 -107 -31 -131 -32 -287 -1 -231 29 -366 124 -555 61 -122 5068 -8789 5118 -8859 165 -233 400 -391 702 -472 112 -31 375 -38 506 -14 315 57 597 233 776 486 34 48 4129 7128 4993 8634 212 369 249 486 249 775 -1 163 -3 183 -31 292 -120 452 -455 782 -910 896 l-108 27 -5140 1 c-2827 1 -5172 -2 -5212 -7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleDown);
export default __webpack_public_path__ + "static/media/triangleDown.9b915ad1dc94cc8afe0478da63b11faf.svg";
export { ForwardRef as ReactComponent };